import React from 'react'

const DecisionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      fill="none"
      viewBox="0 0 36 36"
    >
      <path fill="#D284FC" d="M36 36A36.001 36.001 0 000 0v36"/>
      <path fill="#89C35C" fillOpacity="0.7" d="M36 0H6v30h30V0z"/>
    </svg>
  );
}

export default DecisionIcon
